import { render } from "./online-payment.vue?vue&type=template&id=5cdf4836&scoped=true"
import script from "./online-payment.vue?vue&type=script&lang=js"
export * from "./online-payment.vue?vue&type=script&lang=js"

import "./online-payment.vue?vue&type=style&index=0&id=5cdf4836&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdf4836"]])

export default __exports__